module.exports = __webpack_public_path__ + "gi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gi.svg
// module id = 823
// module chunks = 0